import { render, staticRenderFns } from "./TheUserResourcesAndUsage.vue?vue&type=template&id=0880f95c&"
import script from "./TheUserResourcesAndUsage.vue?vue&type=script&lang=js&"
export * from "./TheUserResourcesAndUsage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports